import React, {Component} from 'react';
export default class TimeTicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageIndex: 0
        };
    }

    change() {
        let imageIndex = 0;
        if (this.state.imageIndex + 1 < this.props.images.length) {
            imageIndex = this.state.imageIndex + 1;
        }
        this.setState({imageIndex})
    }

    componentDidMount() {
        this.interval = setInterval(this.change.bind(this), 5000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <div style={{
                backgroundImage: 'url(' + this.props.images[this.state.imageIndex] + ')'
            }} className="image"/>
        )
    }
}



// WEBPACK FOOTER //
// ./src/js/components/image-switcher.js